import { render } from "./CustomDialog.vue?vue&type=template&id=71ee043d&scoped=true"
import script from "./CustomDialog.vue?vue&type=script&lang=js"
export * from "./CustomDialog.vue?vue&type=script&lang=js"

import "./CustomDialog.vue?vue&type=style&index=0&id=71ee043d&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ee043d"]])

export default __exports__